'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _endsWith = require('lodash/endsWith');

var _endsWith2 = _interopRequireDefault(_endsWith);

var _classificationData = require('@seek/classification-data');

var _worktypes = require('./worktypes');

var _worktypes2 = _interopRequireDefault(_worktypes);

var _states = require('./states');

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locWordList = ['all', 'nsw', 'vic', 'sa', 'nt', 'wa', 'qld', 'tas', 'act', 'nz'];

var getTargetValue = function getTargetValue() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return value.replace(/[^a-z\d]/gi, '').toLowerCase();
};

var splitTargetValues = function splitTargetValues(values, token) {
  return values.split(token).map(function (value) {
    return getTargetValue(value);
  }).filter(function (i) {
    return i;
  });
};

var removeWord = function removeWord(word) {
  return locWordList.indexOf(word) < 0;
};

var removeWords = function removeWords(value) {
  var valueLC = value.toLowerCase();
  var valueArray = valueLC.split(' ');

  return valueArray.filter(removeWord).join('');
};

exports.default = function (_ref, _ref2) {
  var classification = _ref.classification,
      subclassification = _ref.subclassification,
      keywords = _ref.keywords,
      worktype = _ref.worktype,
      salarytype = _ref.salarytype,
      salaryrange = _ref.salaryrange,
      advertiserid = _ref.advertiserid,
      companyid = _ref.companyid,
      graduatesearch = _ref.graduatesearch;
  var areaDescription = _ref2.areaDescription,
      locationDescription = _ref2.locationDescription,
      stateDescription = _ref2.stateDescription,
      locationType = _ref2.type,
      suburbDescription = _ref2.description,
      whereId = _ref2.whereId;

  var targeting = [];

  if (keywords && getTargetValue(keywords)) {
    targeting.push({ key: 'kw', value: getTargetValue(keywords) });
  }

  if (classification) {
    var industries = classification.split(',').map(function (cId) {
      var cls = (0, _classificationData.getClassification)(Number(cId));

      return cls && getTargetValue(cls.name());
    }).filter(function (i) {
      return i;
    });

    if (industries.length) {
      targeting.push({ key: 'ind', value: industries });
    }
  }

  if (subclassification) {
    var occupations = subclassification.split(',').map(function (sId) {
      var subCls = (0, _classificationData.getClassification)(Number(sId));

      return subCls && getTargetValue(subCls.name());
    }).filter(function (i) {
      return i;
    });

    if (occupations.length) {
      targeting.push({ key: 'occ', value: occupations });
    }
  }

  if (worktype) {
    var worktypeValues = worktype.split(',').map(function (wId) {
      return _worktypes2.default[wId];
    });

    targeting.push({ key: 'wt', value: worktypeValues });
  }

  if (salaryrange) {
    var salaryKey = salarytype === 'hourly' ? 'HourlySal' : 'AnnualSal';
    var values = splitTargetValues(salaryrange, '-');

    if (values.length) {
      targeting.push({ key: salaryKey, value: values });
    }
  }

  if (advertiserid) {
    var _values = splitTargetValues(advertiserid, ',');

    if (_values.length) {
      targeting.push({ key: 'advertiser', value: _values });
    }
  }

  if (companyid) {
    var _values2 = splitTargetValues(companyid, ',');

    if (_values2.length) {
      targeting.push({ key: 'company', value: _values2 });
    }
  }

  if (graduatesearch) {
    targeting.push({ key: 'grad', value: 'true' });
  }

  // Location
  if (whereId === 90000) {
    targeting.push({ key: 'loc', value: 'wfh' });

    return targeting;
  }

  if (stateDescription) {
    targeting.push({ key: 'sta', value: _states2.default[stateDescription] });
  }

  if (locationDescription && getTargetValue(locationDescription)) {
    targeting.push({ key: 'loc', value: getTargetValue(locationDescription) });
  }

  if (areaDescription && getTargetValue(areaDescription)) {
    targeting.push({ key: 'area', value: getTargetValue(areaDescription) });
  }

  if (locationType === 'Suburb') {
    var suburbName = suburbDescription;

    if ((0, _endsWith2.default)(suburbDescription, ' AU') || (0, _endsWith2.default)(suburbDescription, ' NZ')) {
      suburbName = suburbDescription.slice(0, -3);
    }

    if (getTargetValue(suburbName)) {
      targeting.push({ key: 'suburb', value: getTargetValue(suburbName) });
    }
  }

  if (locationType === 'Location' && !locationDescription) {
    /*  The search API is no longer sending locationDesription
     *  obviously this is something we need to chase up, but as a quick
     *  fix for the display adverts team I'm forcing all locations to get
     *  a loc value from description property of a location.
     *  See Dave De Run for more info */
    var description = removeWords(suburbDescription);

    if (getTargetValue(description)) {
      targeting.push({ key: 'loc', value: getTargetValue(description) });
    }
    return targeting;
  }

  return targeting;
};